import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input
} from '@angular/core';
import { toObservable, toSignal } from '@angular/core/rxjs-interop';
import { Observable } from 'rxjs';

@Component({
  selector: 'text-ellipsis',
  templateUrl: './text-ellipsis.component.html',
  styleUrl: './text-ellipsis.component.scss',
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TextEllipsisComponent {
  text = input<string | null | undefined>('');
  observableText$ = input<
    Observable<string | null | undefined> | null | undefined
  >(undefined);

  placeholder = input<string>('-');
  tooltipDisabled = input<boolean>(false);

  private _observableText = toSignal(toObservable(this.observableText$));

  private _trimmedValue = computed(() => {
    const value = this.text() || this._observableText();
    if (value === null || value === undefined) {
      return '';
    }
    return `${value}`.trim();
  });

  hasValue = computed(() => this._trimmedValue().length > 0);

  displayValue = computed(() =>
    this.hasValue() ? this._trimmedValue() : this.placeholder()
  );

  tooltipValue = computed(() => (this.hasValue() ? this._trimmedValue() : ''));
}
